import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { api, endpoints } from '../../api';
import { FormBlock, FormItem } from '../../styles/styled';
import { PovsResponseType } from '../NmsMembers/types';

export const PovsLkPage = () => {
  const [currentPovs, setCurrentPovs] = useState<PovsResponseType>({});

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get<PovsResponseType>(endpoints.getUserData());

        setCurrentPovs(response.data);
      } catch (err) {}
    })();
  }, []);

  return (
    <FormBlock margintop="40px" noBorderRadius white>
      <Row gutter={[20, 30]}>
        <Col span={8}>
          <FormItem>
            <div className="text">E-mail представителя</div>
            <div className="dark-text">{currentPovs?.email}</div>
          </FormItem>
        </Col>
        <Col span={8}>
          <FormItem>
            <div className="text">E-mail органа власти</div>
            <div className="dark-text">{currentPovs?.expert?.povs?.email_gov}</div>
          </FormItem>
        </Col>
        <Col span={8}>
          <FormItem>
            <div className="text">Регион </div>
            <div className="dark-text">{currentPovs?.expert?.region?.title}</div>
          </FormItem>
        </Col>
        <Col span={24}>
          <FormItem>
            <div className="text">Наименование организации </div>
            <div className="dark-text">{currentPovs?.expert?.povs?.gov_name}</div>
          </FormItem>
        </Col>
        <Col span={24}>
          <FormItem>
            <div className="text">Адрес нахождения организации </div>
            <div className="dark-text">{currentPovs?.expert?.povs?.gov_loc}</div>
          </FormItem>
        </Col>
        <Col span={24}>
          <FormItem>
            <div className="text">ФИО руководителя органа</div>
            <div className="dark-text">{currentPovs?.expert?.povs?.gov_fio}</div>
          </FormItem>
        </Col>
      </Row>
    </FormBlock>
  );
};
